import mitt, { Handler } from "mitt";
import { getCurrentInstance, onUnmounted } from "vue";

const eventsBus = mitt();
export default {
  ...eventsBus,
  // 重写on，默认在vue组件卸载时自动注销
  on(type, handler) {
    eventsBus.on(type, handler);
    const currentInstance = getCurrentInstance();
    if (currentInstance) {
      onUnmounted(() => eventsBus.off(type, handler));
    }
  },
};